// STORE
import {
  GetListPagePropsT,
  CreateNewListPropsT,
  UpdateListPropsT,
} from "@interfaces/store/internal-list-store-types";
import { createEffect, createEvent, createStore } from "effector";

import { EventStateStoreT } from "@interfaces/common";

import InternalStudyListService from "@services/internal-study-list-service";

import { ListShortDataT } from "@interfaces/internal-study/list";
import { resetAllStates } from "@store/user-store";

// LIST DATA
export const setInternalList = createEvent<ListShortDataT[]>();
export const setInternalInfo = createEvent<ListShortDataT>();

export const $InternalList = createStore<ListShortDataT[]>([])
  .on(setInternalList, (_, newState) => newState)
  .reset(resetAllStates);
export const $InternalInfo = createStore<ListShortDataT>({} as ListShortDataT)
  .on(setInternalInfo, (_, newState) => newState)
  .reset(resetAllStates);

// LIST STATES
export const setInternalListStateLoading = createEvent<boolean>();
export const setInternalListStateError = createEvent<boolean>();
const setInternalListStateFetched = createEvent<boolean>();
const setInternalListStates = createEvent<EventStateStoreT>();

// INFO STATES
export const setInternalInfoStateLoading = createEvent<boolean>();
export const setInternalInfoStateError = createEvent<boolean>();
const setInternalInfoStateFetched = createEvent<boolean>();
const setInternalInfoStates = createEvent<EventStateStoreT>();

export const $InternalListState = createStore<EventStateStoreT>({
  isLoading: true,
  error: false,
  isFetched: false,
})
  .on(setInternalListStateLoading, (oldState, newState) => ({
    ...oldState,
    isLoading: newState,
  }))
  .on(setInternalListStateError, (oldState, newState) => ({
    ...oldState,
    isLoading: false,
    error: true,
  }))
  .on(setInternalListStateFetched, (oldState, newState) => ({
    ...oldState,
    isFetched: newState,
  }))
  .on(setInternalListStates, (_, newState) => newState)
  .reset(resetAllStates);

export const $InternalInfoState = createStore<EventStateStoreT>({
  isLoading: true,
  error: false,
  isFetched: false,
})
  .on(setInternalInfoStateLoading, (oldState, newState) => ({
    ...oldState,
    isLoading: newState,
  }))
  .on(setInternalInfoStateError, (oldState, newState) => ({
    ...oldState,
    isLoading: false,
    error: true,
  }))
  .on(setInternalInfoStateFetched, (oldState, newState) => ({
    ...oldState,
    isFetched: newState,
  }))
  .on(setInternalInfoStates, (_, newState) => newState)
  .reset(resetAllStates);

export const fetchInternalList = createEffect(
  async (companyId: number | undefined) => {
    if (companyId === undefined) {
      return setInternalListStateError(true);
    }
    InternalStudyListService.getAll(companyId, (err, res) => {
      if (err || !res) {
        return setInternalListStateError(true);
      }
      setInternalList(res.data);
      setInternalListStates({
        isLoading: false,
        error: false,
        isFetched: false,
      });
    });
  }
);

export const fetchInternalInfo = createEffect<GetListPagePropsT>(
  async ({ id, companyId }) => {
    setInternalInfoStates({
      isLoading: false,
      error: false,
      isFetched: true,
    });
    InternalStudyListService.getById(id, companyId, (err, res) => {
      if (err || !res) {
        return setInternalInfoStateError(true);
      }
      setInternalInfo(res.data);
      setInternalInfoStates({
        isLoading: false,
        error: false,
        isFetched: false,
      });
    });
  }
);

export const createNewInternalList = createEffect<CreateNewListPropsT>(
  async ({ companyId, title, comission, trainees_members, cb }) => {
    InternalStudyListService.create(
      companyId,
      title,
      comission,
      trainees_members,
      (err, res) => {
        if (err || !res) {
          return cb(err);
        }
        setInternalList([...$InternalList.getState(), res.data]);
        cb(null, res);
      }
    );
  }
);

export const updateInternalList = createEffect<UpdateListPropsT>(
  async ({ id, title, comission, cb }) => {
    InternalStudyListService.update(id, title, comission, (err, res) => {
      if (err || !res) {
        return cb(err);
      }
      setInternalList(
        $InternalList.getState().map((list) => {
          if (list.id === id) {
            list.title = title;
            list.comission = comission;
          }
          return list;
        })
      );
      cb(null);
    });
  }
);

export const removeInternalList = createEffect<(p: { id: number }) => void>(
  async ({ id }) => {
    InternalStudyListService.delete(id, (err, res) => {
      if (err || !res) {
        return console.error("При удалении обучения произошла ошибка");
      }
      const lists = $InternalList.getState();
      const listIndex = lists.findIndex((c) => c.id === id);

      lists.splice(listIndex, 1);
      setInternalList(Array.from(lists));
    });
  }
);
